/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CarrierDeliveryNotesArrayV3 } from '../models/carrier-delivery-notes-array-v-3';
import { ConsigneeDeliveryNotesArrayV3 } from '../models/consignee-delivery-notes-array-v-3';
import { DeliveryNoteInPoolArrayV3 } from '../models/delivery-note-in-pool-array-v-3';
import { getCarrierDeliveryNotesV3 } from '../fn/delivery-notes-v-3/get-carrier-delivery-notes-v-3';
import { GetCarrierDeliveryNotesV3$Params } from '../fn/delivery-notes-v-3/get-carrier-delivery-notes-v-3';
import { getConsigneeDeliveryNotesV3 } from '../fn/delivery-notes-v-3/get-consignee-delivery-notes-v-3';
import { GetConsigneeDeliveryNotesV3$Params } from '../fn/delivery-notes-v-3/get-consignee-delivery-notes-v-3';
import { getDeliveryNotesMetadataInPoolV3 } from '../fn/delivery-notes-v-3/get-delivery-notes-metadata-in-pool-v-3';
import { GetDeliveryNotesMetadataInPoolV3$Params } from '../fn/delivery-notes-v-3/get-delivery-notes-metadata-in-pool-v-3';


/**
 * Enhanced delivery note operations with improved pagination, sorting, and filtering capabilities
 */
@Injectable({ providedIn: 'root' })
export class DeliveryNotesV3Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCarrierDeliveryNotesV3()` */
  static readonly GetCarrierDeliveryNotesV3Path = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes';

  /**
   * Get carrier delivery notes (v3).
   *
   * Get delivery notes for carrier with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery notes from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDeliveryNotesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNotesV3$Response(params: GetCarrierDeliveryNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<CarrierDeliveryNotesArrayV3>> {
    const obs = getCarrierDeliveryNotesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get carrier delivery notes (v3).
   *
   * Get delivery notes for carrier with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery notes from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDeliveryNotesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNotesV3(params: GetCarrierDeliveryNotesV3$Params, context?: HttpContext): Observable<CarrierDeliveryNotesArrayV3> {
    const resp = this.getCarrierDeliveryNotesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CarrierDeliveryNotesArrayV3>): CarrierDeliveryNotesArrayV3 => r.body)
    );
  }

  /** Path part for operation `getConsigneeDeliveryNotesV3()` */
  static readonly GetConsigneeDeliveryNotesV3Path = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes';

  /**
   * Get consignee delivery notes (v3).
   *
   * Get delivery notes for consignee with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery notes from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDeliveryNotesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNotesV3$Response(params: GetConsigneeDeliveryNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeDeliveryNotesArrayV3>> {
    const obs = getConsigneeDeliveryNotesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get consignee delivery notes (v3).
   *
   * Get delivery notes for consignee with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery notes from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDeliveryNotesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNotesV3(params: GetConsigneeDeliveryNotesV3$Params, context?: HttpContext): Observable<ConsigneeDeliveryNotesArrayV3> {
    const resp = this.getConsigneeDeliveryNotesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsigneeDeliveryNotesArrayV3>): ConsigneeDeliveryNotesArrayV3 => r.body)
    );
  }

  /** Path part for operation `getDeliveryNotesMetadataInPoolV3()` */
  static readonly GetDeliveryNotesMetadataInPoolV3Path = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes';

  /**
   * Get consignor delivery notes data w/o load carriers (v3).
   *
   * Get delivery notes metadata from delivery note pool.
   * Property loadCarriers is always an empty array. To get the
   * load carriers please use the load carriers endpoint.
   * Supports enhanced pagination and sorting with improved performance.
   * Can fetch delivery notes from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeliveryNotesMetadataInPoolV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryNotesMetadataInPoolV3$Response(params: GetDeliveryNotesMetadataInPoolV3$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteInPoolArrayV3>> {
    const obs = getDeliveryNotesMetadataInPoolV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get consignor delivery notes data w/o load carriers (v3).
   *
   * Get delivery notes metadata from delivery note pool.
   * Property loadCarriers is always an empty array. To get the
   * load carriers please use the load carriers endpoint.
   * Supports enhanced pagination and sorting with improved performance.
   * Can fetch delivery notes from multiple sites using the organizationSiteKeys query parameter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeliveryNotesMetadataInPoolV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeliveryNotesMetadataInPoolV3(params: GetDeliveryNotesMetadataInPoolV3$Params, context?: HttpContext): Observable<DeliveryNoteInPoolArrayV3> {
    const resp = this.getDeliveryNotesMetadataInPoolV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DeliveryNoteInPoolArrayV3>): DeliveryNoteInPoolArrayV3 => r.body)
    );
  }

}
